import { render, staticRenderFns } from "./pic&video.vue?vue&type=template&id=fc2282e6&scoped=true&"
import script from "./pic&video.vue?vue&type=script&lang=js&"
export * from "./pic&video.vue?vue&type=script&lang=js&"
import style0 from "./pic&video.vue?vue&type=style&index=0&id=fc2282e6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2282e6",
  null
  
)

export default component.exports